import { $, w } from './constants';

function updateFloatingButtonsOnScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
    const isTop = scrollTop <= 30;

    if (isTop) {
        $('#wa_btn').addClass('active');
        $('#faq_btn').addClass('active');
        $('.chatbot_JS').addClass('active');
    } else {
        $('#wa_btn').removeClass('active');
        $('#faq_btn').removeClass('active');
        $('.chatbot_JS').removeClass('active');
    }
}

$(function () {
    updateFloatingButtonsOnScroll();

    $(window).on('scroll', updateFloatingButtonsOnScroll);
    $(window).on('resize', updateFloatingButtonsOnScroll);
    $(window).on('load', updateFloatingButtonsOnScroll);
});